<template>
    <div ref="pdfRef"></div>
</template>
<script>
import { pdfRender, Props } from '@custouch/resource-pdf'
import '@custouch/resource-pdf/dist/style.css'
import { UAID } from '@/configs/constants'
export default {
    props: {
        options: Props,
        title: String
    },
    mounted(){
        if(!this.$refs.pdfRef) return
        let instance
        instance = pdfRender.render(this.$refs.pdfRef,{
            viewParams: {
                title: this.title,
                uaId: UAID,
            },
            ...this.options
        })
    }
}
</script>